import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { parseCookies } from 'nookies';
import { Env } from '@/consts/Env';
import { httpClient } from '@/queries/httpClient';

type UserBonusesState = {
  data: any; // Replace with a more specific type if available
  loading: boolean;
  error: null | boolean;
};

export const getBonusesData = createAsyncThunk(
  'userBonuses/getBonusesData',
  async () => {
    return await httpClient.get(
      `${Env.NEXT_PUBLIC_API}/api/user/bonuses/`,
      {
        skipAuth: true,
        headers: { Authorization: `Bearer ${parseCookies().accessToken}` },
      },
    );
  },
);

const initialState: UserBonusesState = {
  data: {},
  loading: true,
  error: null,
};

const userBonusesSlice = createSlice({
  name: 'userBonuses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBonusesData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(getBonusesData.pending, () => {})
      .addCase(getBonusesData.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });
  },
});

export default userBonusesSlice.reducer;
